/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-restricted-imports */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, createRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import * as dayjs from "dayjs";
import "dayjs/locale/id";

import { TabView, TabPanel } from "primereact/tabview";

import iconDownload from "../../../assets/img/download-blue.svg";
import CoinImage from "../../../assets/img/icon-coin.svg";
import UsersImage from "../../../assets/img/icon-users.svg";
import ClockImage from "../../../assets/img/icon-clock.svg";
import WinnerImage from "../../../assets/img/winner.svg";
import ImgInvite from "../../../assets/img/invite_writer.svg";
import ImgClose from "../../../assets/img/close_project.svg";
import ImgPublish from "../../../assets/img/publish_project.svg";

import DialogUsers from "./Components/PopupListUser";

import DialogAlert from "../../../components/dialog/DialogAlert";

import TabsUserProject from "../../../components/tabs/TabsUserProject";
import ButtonIconLeft from "../../../components/button/ButtonIconLeft";
import LinkEdit from "../../../components/button/LinkEdit";
import {
  TitleLoad,
  DetailPageLoad,
} from "../../../components/loading/loadingContent";
import StatusBadge from "../../../components/badge/StatusBadge";

import {
  resetStateProjectAction,
  userInvitableAction,
  getDetailProjectAction,
  updateProjectPmStatusAction,
} from "../../../../redux/action/projectAction";
import { resetStateUserAction } from "../../../../redux/action/userAction";
import firebase from "../../../../redux/service/firebase/firebase";
import DialogPm from "./Components/PopupListPm";
import { Button } from "react-bootstrap";

import crypto from "crypto";

// openai
const { Configuration, OpenAIApi } = require("openai");
const configuration = new Configuration({
  apiKey:
    "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",
});
const openai = new OpenAIApi(configuration);

const DetailProjectPmModule = (props) => {
  const QueryParams = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const firestore = firebase.firestore();

  const [openNotice, setOpenNotice] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [typeStatus, setTypeStatus] = useState("");
  const [openDialog, setOpenDialog] = useState(null);
  const [openDialogPm, setOpenDialogPm] = useState(false);
  const [assignPm, setAssignPm] = useState(false);
  const [openAlert, setOpenAlert] = useState({
    dialog: false,
    type: null,
    title: null,
    desc: null,
  });
  const [disabledGenerate, setDisabledGenerate] = useState(false);
  const [loadingGenerate, setLoadingGenerate] = useState(false);

  const {
    dataGetDetailProject,
    loadingGetDetailProject,
    successAssignProject,
    loadingUpdateProject,
    successUpdateProject,
    errUpdateProject,
    userInvitableParams,
    successUpdateProjectPmStatus,
  } = useSelector((state) => state.project);
  const { dataGetTargetMedia } = useSelector((state) => state.service);

  const { successInviteUser, errInviteUser } = useSelector(
    (state) => state.user
  );
  const { users } = useSelector((state) => state.auth);
  const isAssigned =
    users?.user?.type === "pm" || dataGetDetailProject?.pmId === users?.uid;
  const pdfRef = createRef();

  const statusOrder = (status) => {
    switch (status) {
      case "published":
        return "1";
      case "winner":
        return "2";
      case "approved":
        return "3";
      case "sent":
        return "4";
      case "revision":
        return "5";
      case "ongoing":
        return "6";
      case "reject":
        return "7";
      case "removed":
        return "8";
      default:
        return "9";
    }
  };

  const getListProject = async () => {
    return await firestore
      .collection("writerProjects")
      .where("projectId", "==", props.projectId)
      .orderBy("updatedAt", "desc")
      .onSnapshot(
        (docs) => {
          const temp = [];
          docs.forEach((doc) =>
            temp.push({
              ...doc.data(),
              id: doc.id,
            })
          );
          // eslint-disable-next-line no-unused-expressions
          const sortedList = temp
            ?.map((users) => {
              return {
                ...users,
                statusOrder: statusOrder(users?.status),
              };
            })
            .sort((a, b) => b?.updatedAt - a?.updatedAt);

          setProjectList(sortedList);
        },
        (error) => {
          console.error("error", error);
        }
      );
  };

  useEffect(() => {
    if (props.projectId) {
      getListProject();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.projectId]);

  useEffect(() => {
    if (dataGetDetailProject && !dataGetDetailProject?.price && isAssigned) {
      setOpenNotice(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataGetDetailProject, dataGetDetailProject?.price]);

  useEffect(() => {
    if (successAssignProject) {
      setOpenAlert({
        dialog: true,
        type: "success",
        title: "Berhasil Mengundang Penulis",
        desc: "Sistem akan mengirimkan notifikasi ke email penulis",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successAssignProject]);

  useEffect(() => {
    if (successInviteUser) {
      setOpenAlert({
        dialog: true,
        type: "success",
        title: "Berhasil Undang Penulis",
        desc: "Sistem akan mengirimkan notifikasi ke email penulis",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successInviteUser]);

  useEffect(() => {
    if (successUpdateProjectPmStatus) {
      setOpenAlert({
        dialog: true,
        type: "success",
        title:
          typeStatus === "publish"
            ? "Project Telah Diterbitkan"
            : "Project Telah Ditutup",
        desc:
          typeStatus === "publish"
            ? "Penulis dapat melihat project ini dari halaman project"
            : "Project telah selesai",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUpdateProjectPmStatus]);

  useEffect(() => {
    if (successUpdateProject && assignPm) {
      setAssignPm(false);
      setOpenAlert({
        dialog: true,
        type: "success",
        title: "Assign Project Manajer Berhasil",
        desc: "Project Manajer berhasil ditambah",
      });
      setAssignPm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUpdateProject]);

  useEffect(() => {
    if (errUpdateProject) {
      setOpenAlert({
        dialog: true,
        type: "error",
        title:
          typeStatus === "publish"
            ? "Project Gagal Diterbitkan"
            : "Project Gagal Ditutup",
        desc:
          typeStatus === "publish"
            ? "Gagal menerbitkan project"
            : "Gagal menutup project",
      });
    }
    if (errUpdateProject && assignPm) {
      setAssignPm(false);
      setOpenAlert({
        dialog: true,
        type: "error",
        title: "Assign Project Manajer Gagal",
        desc: "Project Manajer gagal ditambah",
      });
      setAssignPm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errUpdateProject]);

  useEffect(() => {
    if (errInviteUser) {
      setOpenAlert({
        dialog: true,
        type: "error",
        title: "Gagal Undang Penulis",
        desc: "Penulis gagal diundang",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errInviteUser]);

  useEffect(() => {
    if (projectList?.length > 0) {
      const hasGeneratedArticle = projectList?.some(
        (project) => project.userData.name === "AI Writer"
      );

      setDisabledGenerate(hasGeneratedArticle);
    }
  }, [projectList]);

  const closeAlert = () => {
    setOpenAlert({
      dialog: false,
      type: null,
      title: null,
      desc: null,
      actionDialog: null,
      actionText: null,
      cancelText: null,
    });
    setOpenDialog(null);
    dispatch(resetStateProjectAction());
    dispatch(resetStateUserAction());
    if (openAlert?.type === "success" && typeStatus?.length > 0) {
      setTypeStatus("");
      dispatch(getDetailProjectAction(QueryParams.projectId));
    } else {
      setTypeStatus("");
    }
  };

  const handleCloseProject = () => {
    const pmCloseProject = () => {
      const data = {
        status: "done",
      };
      dispatch(updateProjectPmStatusAction(QueryParams.projectId, data));
    };
    setOpenAlert({
      dialog: true,
      type: "warning",
      title: "Anda yakin ingin menutup project ini?",
      desc: "Penulis tidak akan bisa mengirim tulisan di project ini lagi",
      actionDialog: () => pmCloseProject(),
      actionText: "TUTUP",
      cancelText: "BATAL",
    });
  };

  const handlePublish = () => {
    const publishAction = () => {
      const data = {
        status: "ongoing",
      };
      dispatch(updateProjectPmStatusAction(QueryParams.projectId, data));
    };
    setTypeStatus("publish");
    setOpenAlert({
      dialog: true,
      type: "warning",
      title: "Terbitkan project ini?",
      desc: "Harap pastikan data project sudah benar",
      actionDialog: () => publishAction(),
      actionText: "TERBITKAN",
      cancelText: "BATAL",
    });
  };

  const closeDialogInvite = () => {
    setOpenDialog(null);
    const params = {
      ...userInvitableParams,
      q: "",
    };
    dispatch(userInvitableAction(QueryParams.projectId, params));
  };

  const openPm = () => {
    setAssignPm(true);
    setOpenDialogPm(true);
  };

  const closePm = () => {
    setAssignPm(false);
    setOpenDialogPm(false);
  };

  const openEditPage = () => {
    setOpenNotice(false);
    history.push(`/admin/pm/edit-project/${QueryParams?.projectId}`);
  };

  const closeDialogBrief = () => {
    setOpenNotice(false);
    history.goBack();
  };

  // generate openai
  const handleGenerate = async (projectId) => {
    setDisabledGenerate(true);
    setLoadingGenerate(true);

    const hashId = crypto
      .createHash("md5")
      .update(`${projectId}1JdevJGrzegVMmfgAf4ibXSGPXx1`)
      .digest("hex");

    try {
      const selectedData = dataGetDetailProject.storyAngles.filter(
        (item) => item.isSelected === true
      );
      const talkingPointsArray = selectedData?.map(
        (item) => item.talkingPoints
      );

      let media = dataGetDetailProject?.target?.media;
      if (media) {
        media = media.replace(/\s+/g, "_").toLowerCase();
      }

      // get media reference
      const mediaReference = dataGetTargetMedia
        ?.filter((mediaItem) => mediaItem.targetMedia === media)
        .map((mediaItem) => mediaItem?.contentText)[0];

      const chatCompletion = await openai.createChatCompletion({
        model: "gpt-4o",
        messages: [
          {
            role: "user",
            content: `
CONTEXT
You are a professional Public Relations expert and press release writer specializing in data-driven, media-friendly, reader-friendly announcements.
Your goal is to write press releases in the style of Zillow: informative, well-structured, objective, and engaging.
The release must be designed for journalists, analysts, and the general public, with a focus on clarity, authority, and relevance.
You are writing on behalf of (company name), which operates in the (industry or sector) space.
---
INSTRUCTIONS
Write the press release in Bahasa Indonesia and follow these steps exactly:
The ourput should be in document tag to show in website.
Structure the release using this format:
1. Headline
2. Subheadline (optional)
3. Dateline
4. Lead Paragraph
5. Body Content (do not use sub heading in this area and expected length 700 words)
6. Quote(s) from Key Personnel
7. Boilerplate
8. Media Contact Information
Use this style and tone throughout:
- Point of View: Third-person
- Tone: Neutral, professional, and authoritative - never hyped
- Language:
  - Clear and plain, without jargon
  - Explain any necessary technical terms
  - Active voice and concise sentence structure
  - Avoid filler or fluff
- Media-Friendly Quotes:
  - Include 1-2 quotes from relevant executives or subject-matter experts
  - Make the quotes natural and insightful, not repetitive
  - Use punchy, quotable soundbites
  - Quote format: (Spokesperson name), (Title), said: "(Quote)"
Data and Insight Integration:
- Present relevant statistics, trends, or numbers
- Provide context for what the data means and why it matters
- Examples include:
  - Percentages (e.g., “58% of short-term rental hosts...”)
  - Metro comparisons (e.g., “Rent increases in Austin outpaced income growth by 12%”)
Audience Optimization:
- Write for:
  - industry professionals
  - ${media} professionals
  - journalists
- Include a Call-to-Action (CTA), if relevant:
  - E.g., "Read the full report", "Visit the product page", "Book a demo"
  - Include the appropriate link
Brand Consistency:
- Match the company's brand voice:
  - Descriptive, factual, and informative
- Keep formatting clean and professional:
  - Use subheadings or bullet points as needed for clarity
Final Review Checklist:
- Verify accuracy of all data, names, and facts
- Proofread for grammar, spelling, and readability
- Ensure tone and formatting match brand and media standards
- Check for legal compliance if financial or regulated information is included
---
CONSTRAINTS
- NEVER USE these words:
  landmark, revolutionary, groundbreaking, turnkey, state of the art, best in class, cutting-edge, leading edge, dazzling, stunning, dramatic, amazing
- RARELY USE these words — only when contextually justified:
  unique, iconic, thrilled, innovative, strategic, utilize, leverage, revolutionize, leading, seamless
- Tone: Authoritative, but accessible.
- Perspective: Always third-person.
- Length: Target minimum 1000 words and maximul 2000 words.
---
INPUTS
Please include the following:
- Company Name: ${dataGetDetailProject?.clientCompany?.companyName}
- Announcement Type: ${dataGetDetailProject.releaseCategory}
- Core Message: ${dataGetDetailProject.attribution}
- Story Angle: ${dataGetDetailProject.title}
- Objective of the article: ${dataGetDetailProject.objective}
- Keyword: ${dataGetDetailProject.searchKeyword}
- Deadline: ${dataGetDetailProject.deadlineDate}
- Key Statistics or Data Points: please add-on some relevant data or statistics. You can also use this talking points for references: ${talkingPointsArray.toString()}
- Executive or Expert Quotes: include full quote, ${
              dataGetDetailProject.clientName
            }, and Corporate Representative
- Target Audience: for ${media}, age ${dataGetDetailProject.target.age}, ${
              dataGetDetailProject.target.sex
            } gender, unit econimic ${dataGetDetailProject.target.ses.toString()}, and ${dataGetDetailProject.target.stakeholders.toString()} stakeholder.
- Call to Action: (e.g., link to full report or demo request)
- Boilerplate Text: create stunning boilerplate in 1-2 paragraph based on this company background: ${
              dataGetDetailProject?.clientCompany?.companyBackground
            }
- Media Contact Info: ${dataGetDetailProject?.clientName}, ${
              dataGetDetailProject?.clientPosition
            }, ${dataGetDetailProject.clientEmail}, and ${
              dataGetDetailProject?.clientPhone
            }`,
          },
        ],
      });

      await firestore
        .collection("writerProjects")
        .doc(hashId)
        .set({
          title: dataGetDetailProject.title,
          deadline: dataGetDetailProject.deadlineDate,
          articleTitle: dataGetDetailProject.title,
          articleContent: chatCompletion.data.choices[0].message.content || "",
          thumbnail: dataGetDetailProject.thumbnail,
          status: "draft",
          category: dataGetDetailProject.category,
          type: dataGetDetailProject.type,
          jobNumber: dataGetDetailProject.jobNumber,
          clientId: dataGetDetailProject.clientId,
          picId: dataGetDetailProject.picId,
          clientCompanyId: dataGetDetailProject.clientCompany.companyId,
          pmData: {
            pmName: dataGetDetailProject.pmName || null,
            pmId: dataGetDetailProject.pmId || null,
            type: "general_pm",
          },
          projectId,
          price: dataGetDetailProject.price,
          userData: {
            name: "AI Writer",
            type: "writer",
          },
          createdAt: new Date(),
          updatedAt: new Date(),
        });

      await firestore
        .collection("writerProjects")
        .doc(hashId)
        .collection("draft")
        .doc("default")
        .set(
          {
            articleTitle: dataGetDetailProject.title,
            articleContent: chatCompletion.data.choices[0].message.content,
            articleImage: null,
          },
          { merge: true }
        );

      console.log("Updating documents for projectId:", projectId);
    } catch (error) {
      console.log(error);
    } finally {
      setDisabledGenerate(false);
      setLoadingGenerate(false);
    }
  };

  let categoryName;
  if (dataGetDetailProject?.type === "pr") {
    categoryName = "Press Release";
  } else if (dataGetDetailProject?.type === "distribution_media") {
    categoryName = "Media Distribusi";
  } else {
    categoryName = "Artikel";
  }

  const keywords = dataGetDetailProject?.searchKeyword?.split(",");

  return (
    <>
      <div className="card card-dashboard">
        <div className="card-header">
          {loadingGetDetailProject ? (
            <TitleLoad />
          ) : (
            <>
              <div className="card-title">
                <div
                  className="card-title-back"
                  onClick={() => history.goBack()}
                >
                  <span className="icon-back"></span>
                </div>
                <h2 className="card-title-text">Detail Project</h2>
              </div>
              <div className="card-header-right">
                {dataGetDetailProject?.status === "ongoing" && (
                  <Button
                    disabled={disabledGenerate}
                    onClick={() => handleGenerate(QueryParams?.projectId)}
                  >
                    Generate Article
                  </Button>
                )}

                {!isAssigned && <StatusBadge status="only_view" />}

                {dataGetDetailProject?.status !== "done" && isAssigned && (
                  <LinkEdit
                    label="edit"
                    link={`/admin/pm/edit-project/${QueryParams?.projectId}`}
                    className="ml-2"
                  />
                )}
              </div>
            </>
          )}
        </div>
        <div className="card-body px-0">
          {loadingGetDetailProject ? (
            <div className="project-info-wrapp">
              <DetailPageLoad />
            </div>
          ) : (
            <>
              <div className="project-detail-top">
                <div className="project-info-wrapp">
                  <div className="project-image">
                    <img src={dataGetDetailProject?.thumbnail} alt="tumbnail" />
                  </div>
                  <div className="project-info">
                    <div className="info-row-title">
                      <h3>{dataGetDetailProject?.title}</h3>
                      <div className="d-flex align-items-center">
                        <h6>
                          Nomor Pekerjaan: {dataGetDetailProject?.jobNumber}
                        </h6>
                        <StatusBadge
                          status={dataGetDetailProject?.status}
                          className="ml-3"
                        />
                      </div>
                    </div>
                    <div className="info-row">
                      <div className="info">
                        <img src={CoinImage} alt="" />
                        <NumberFormat
                          prefix={"Rp "}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          displayType="text"
                          value={dataGetDetailProject?.price}
                          renderText={(value) => <p>{value}</p>}
                        />
                      </div>
                      <div className="info">
                        <img src={ClockImage} alt="" />
                        <p>
                          Deadline{" "}
                          {dayjs(dataGetDetailProject?.deadlineDate?.toDate())
                            .locale("id")
                            .format("DD MMMM YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="info-row">
                      <div className="info">
                        <img src={UsersImage} alt="" />
                        <NumberFormat
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          displayType="text"
                          value={dataGetDetailProject?.nWriter}
                          renderText={(value) => (
                            <p>
                              <strong> {value} </strong> Penulis Bergabung
                            </p>
                          )}
                        />
                      </div>
                      <div className="info">
                        <img src={WinnerImage} alt="" />
                        <NumberFormat
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          displayType="text"
                          value={
                            dataGetDetailProject?.totalWinner
                              ? dataGetDetailProject?.totalWinner
                              : 0
                          }
                          renderText={(value) => <p>{value}/</p>}
                        />
                        <NumberFormat
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          displayType="text"
                          value={dataGetDetailProject?.winnerQuota}
                          renderText={(value) => (
                            <p>
                              <strong>{value}</strong> Tulisan Terpilih
                            </p>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="project-description">
                    <p>{dataGetDetailProject?.description}</p>
                  </div>
                  <div className="project-action">
                    <div className="action-left">
                      {dataGetDetailProject?.briefUrl && (
                        <a
                          className="btn-download brief"
                          href={dataGetDetailProject?.briefUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={iconDownload} />
                          Unduh Ringkasan
                        </a>
                      )}
                    </div>
                    <div className="action-right">
                      {isAssigned && (
                        <>
                          {((dataGetDetailProject?.status === "published" &&
                            (!dataGetDetailProject?.totalWinner ||
                              dataGetDetailProject?.totalWinner <
                                dataGetDetailProject?.winnerQuota)) ||
                            (dataGetDetailProject?.status === "ongoing" &&
                              (!dataGetDetailProject?.totalWinner ||
                                dataGetDetailProject?.totalWinner <
                                  dataGetDetailProject?.winnerQuota))) && (
                            <>
                              {isAssigned && (
                                <ButtonIconLeft
                                  className="ml-2"
                                  label="UNDANG PENULIS"
                                  image={ImgInvite}
                                  onClick={() => setOpenDialog("users")}
                                />
                              )}
                            </>
                          )}
                          {dataGetDetailProject?.status === "new" && (
                            <>
                              {(!dataGetDetailProject?.pmName ||
                                !dataGetDetailProject?.pmId) && (
                                <ButtonIconLeft
                                  className="ml-2"
                                  label="ASSIGN PM"
                                  image={ImgInvite}
                                  onClick={() => openPm()}
                                />
                              )}
                              <ButtonIconLeft
                                className="ml-2"
                                label="TERBITKAN"
                                image={ImgPublish}
                                onClick={() => handlePublish()}
                                loading={loadingUpdateProject}
                              />
                            </>
                          )}
                          {(dataGetDetailProject?.status === "published" ||
                            dataGetDetailProject?.status === "ongoing") && (
                            <ButtonIconLeft
                              className="ml-2"
                              label="TUTUP PROJECT"
                              color="danger"
                              image={ImgClose}
                              onClick={() => handleCloseProject()}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="project-detail-bottom">
                <div className="tab-project" ref={pdfRef}>
                  <TabView>
                    <TabPanel header="Ringkasan Project">
                      <div className="accordion-project-wrapper">
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <h3>Informasi Project</h3>
                          </div>
                          <div className="col-12 col-sm-4">
                            <h6>Jenis Project</h6>
                            <div className="box-text">{categoryName}</div>
                          </div>
                          <div className="col-12 col-sm-4">
                            <h6>Kategori Project</h6>
                            <div className="box-text">
                              {dataGetDetailProject?.category}
                            </div>
                          </div>
                          <div className="col-12 col-sm-4">
                            <h6>Manajer Project</h6>
                            <div className="box-text">
                              {dataGetDetailProject?.pmName ||
                                users?.user?.name}
                            </div>
                          </div>
                          <div className="col-12 col-sm-12">
                            <hr />
                          </div>
                          <div className="col-12 col-sm-12">
                            <h3>Informasi Klien</h3>
                          </div>
                          <div className="col-12 col-sm-12">
                            <h2>{dataGetDetailProject?.clientCompany?.name}</h2>
                          </div>
                          <div className="col-12 col-sm-12">
                            <p>
                              {
                                dataGetDetailProject?.clientCompany
                                  ?.companyBackground
                              }
                            </p>
                          </div>
                          <div className="col-12 col-sm-6">
                            <h6>Bidang Usaha</h6>
                            <div className="box-text">
                              {
                                dataGetDetailProject?.clientCompany
                                  ?.businessField
                              }
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <h6>Kata Kunci Pencarian</h6>
                            <div className="d-flex flex-wrap">
                              {keywords?.map((item) => (
                                <div className="box-text list">{item}</div>
                              ))}
                            </div>
                          </div>
                          <div className="col-12 col-sm-12">
                            <hr />
                          </div>
                          <div className="col-12 col-sm-12">
                            <h3>Target Pembaca</h3>
                          </div>
                          <div className="col-12 col-sm-3">
                            <h6>Usia</h6>
                            <div className="box-text">
                              {dataGetDetailProject?.target?.age}
                            </div>
                          </div>
                          {dataGetDetailProject?.target?.media && (
                            <div className="col-12 col-sm-3">
                              <h6>Media</h6>
                              <div className="box-text">
                                {dataGetDetailProject?.target?.media}
                              </div>
                            </div>
                          )}
                          <div className="col-12 col-sm-3">
                            <h6>Jenis kelamin</h6>
                            <div className="box-text">
                              {dataGetDetailProject?.target?.sex}
                            </div>
                          </div>
                          <div className="col-12 col-sm-3">
                            <h6>Stakeholder</h6>
                            <div className="d-flex flex-wrap">
                              {dataGetDetailProject?.target?.stakeholders?.map(
                                (item) => (
                                  <div className="box-text list">{item}</div>
                                )
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-sm-12">
                            <hr />
                          </div>
                          <div className="col-12 col-sm-12">
                            <h3>Ruang Lingkup Rilis</h3>
                          </div>
                          {dataGetDetailProject?.type === "pr" && (
                            <>
                              <div className="col-12 col-sm-4">
                                <h6>Kategori Rilis</h6>
                                <div className="box-text mb-5">
                                  {dataGetDetailProject?.releaseCategory}
                                </div>
                              </div>
                            </>
                          )}

                          <div className="col-12 col-sm-12">
                            <h6>Objek Komunitas yang Ingin Dicapai</h6>
                            <p>{dataGetDetailProject?.objective}</p>
                            <h6>
                              Atribut Quote dan Pesan yang Ingin Disampaikan
                            </h6>
                            <p>{dataGetDetailProject?.attribution}</p>
                            <h6>
                              Hal yang Diperhatikan dalam Penulisan Release
                            </h6>
                            <p>{dataGetDetailProject?.releaseNote}</p>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header="Daftar Tulisan">
                      <TabsUserProject
                        userType={users?.user?.type}
                        writerList={projectList}
                        link={{
                          writer: `/admin/pm/detail-project/${QueryParams.projectId}/preview?writer=`,
                          pic: `/admin/pm/detail-project/${QueryParams.projectId}/article?id=`,
                        }}
                      />
                    </TabPanel>
                  </TabView>
                </div>
              </div>
            </>
          )}
        </div>

        {loadingGenerate && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <div className="loading-text">Generating Article...</div>
          </div>
        )}
      </div>

      <DialogAlert
        type="warning"
        visible={openNotice}
        actionDialog={() => openEditPage()}
        actionText="LENGKAPI DATA"
        closeDialog={() => closeDialogBrief()}
        title="Data Project Belum Lengkap"
        text="Silahkan lengkapi data terlebih dahulu"
        cancelText="TUTUP"
      />

      <DialogPm
        dialogPm={openDialogPm}
        closeDialog={() => closePm()}
        projectId={props.projectId}
      />

      <DialogUsers
        dialogUser={openDialog}
        openDialogInvite={() => setOpenDialog("invite")}
        openDialogUsers={() => setOpenDialog("users")}
        closeDialog={() => closeDialogInvite()}
      />

      <DialogAlert
        type={openAlert.type}
        visible={openAlert.dialog}
        closeDialog={() => closeAlert()}
        title={openAlert.title}
        text={openAlert.desc}
        actionDialog={openAlert?.actionDialog}
        actionText={openAlert?.actionText}
        cancelText={openAlert?.cancelText}
        loading={loadingUpdateProject}
      />
    </>
  );
};

export default DetailProjectPmModule;
